import React from "react";

export function NoComments(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width="332" height="148" viewBox="0 0 332 148" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect x="46.5" y="32.5" width="159" height="55" rx="7.5" fill="#FDFDFE" />
      <rect x="46.5" y="32.5" width="159" height="55" rx="7.5" stroke="#EFF3F6" />
      <circle cx="62" cy="48" r="8" fill="#E6ECF1" />
      <rect x="78" y="45" width="48" height="6" rx="3" fill="#E6ECF1" />
      <rect x="78" y="60" width="116" height="6" rx="3" fill="#E6ECF1" />
      <rect x="78" y="70" width="60" height="6" rx="3" fill="#E6ECF1" />
      <rect x="130" y="45" width="20" height="6" rx="3" fill="#E6ECF1" />
      <rect x="126.5" y="60.5" width="159" height="55" rx="7.5" fill="#FDFDFE" />
      <rect x="126.5" y="60.5" width="159" height="55" rx="7.5" stroke="#EFF3F6" />
      <circle cx="142" cy="76" r="8" fill="#E6ECF1" />
      <rect x="158" y="73" width="48" height="6" rx="3" fill="#E6ECF1" />
      <rect x="158" y="88" width="116" height="6" rx="3" fill="#E6ECF1" />
      <rect x="158" y="98" width="60" height="6" rx="3" fill="#E6ECF1" />
      <rect x="210" y="73" width="20" height="6" rx="3" fill="#E6ECF1" />
    </svg>
  );
}
